export default __webpack_public_path__ + "static/download-on-the-app-store-apple (1)@3x-017ff6367b6007fe14ee29d3d4cd7e82.svg";